// extracted by mini-css-extract-plugin
module.exports = {"primary":"#e58e26","light":"#dcdcdc"};